// extracted by mini-css-extract-plugin
module.exports = {"bodyuCourseWrapper":"style__bodyuCourseWrapper__oPFN1"};